module.exports = __webpack_public_path__ + "fonts/proximasoft-bold-webfont.ab76da5.eot";